import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { getNewsItem } from '../services/firestoreService';
import { NewsItem } from '../types';
import PageShell from '../components/PageShell';
import { renderArticle } from '../utils/article';

const NewsDetail = () => {
  const { id = '' } = useParams();
  const [item, setItem] = useState<NewsItem | null | undefined>(undefined);

  useEffect(() => {
    getNewsItem(id).then(setItem).catch(() => setItem(null));
  }, [id]);

  return (
    <PageShell title={item?.title || 'Actualité'}>
      <article className="max-w-3xl mx-auto">
        {item === undefined ? (
          <p className="text-brand-pink-600">Chargement...</p>
        ) : item === null ? (
          <div>
            <h1 className="heading text-3xl mb-4">Actualité introuvable</h1>
            <p className="text-brand-pink-900/70 mb-6">Elle a peut-être été supprimée.</p>
            <Link to="/actualites" className="btn-secondary">Voir toutes les actualités</Link>
          </div>
        ) : (
          <>
            <p className="eyebrow mb-3">{format(new Date(item.date), 'd MMMM yyyy', { locale: fr })}</p>
            <h1 className="heading text-3xl md:text-5xl mb-8">{item.title}</h1>
            {item.image && (
              <img src={item.image} alt="" className="w-full max-h-[480px] object-cover rounded-3xl mb-8 bg-brand-pink-100" />
            )}
            <div className="text-lg text-brand-pink-900/80 leading-relaxed">
              {renderArticle(item.content)}
            </div>
            <Link to="/actualites" className="btn-secondary mt-12">Toutes les actualités</Link>
          </>
        )}
      </article>
    </PageShell>
  );
};

export default NewsDetail;
